export default __webpack_public_path__ + "static/j_baumann-a05dd6526bc21d3c88d6c8d6ef26e4d3.jpg";